const key = purpose => `trainnova.email-code.${purpose}`;
export function readCodeFlow(purpose) {
  try {
    const v = JSON.parse(localStorage.getItem(key(purpose)) || 'null');
    if (v && v.purpose === purpose && typeof v.challenge_id === 'string' &&
        /^[\w-]{40,128}$/.test(v.challenge_id) && typeof v.identifier === 'string' &&
        v.identifier.length <= 254 && Number.isFinite(v.expiresAt) &&
        v.expiresAt > Date.now() && v.expiresAt <= Date.now() + 600000 &&
        Number.isFinite(v.resendAt)) return v;
  } catch { /* Storage may be unavailable; in-memory flow still works. */ }
  clearCodeFlow(purpose);
  return null;
}
export function clearCodeFlow(purpose) {
  try { localStorage.removeItem(key(purpose)); } catch { /* optional persistence */ }
}
export function saveCodeFlow(data, identifier, purpose) {
  const flow = { challenge_id: data.challenge_id, identifier, purpose,
    expiresAt: Date.now() + Math.min(data.expires_in, 600) * 1000,
    resendAt: Date.now() + data.resend_after * 1000 };
  try { localStorage.setItem(key(purpose), JSON.stringify(flow)); } catch { /* optional persistence */ }
  return flow;
}
export function codeError(error, sv) {
  if (error?.response?.status === 429) return sv ? 'För många försök. Vänta innan du försöker igen.' : 'Too many attempts. Please wait before trying again.';
  if (!error?.response || error.response.status >= 500) return sv ? 'Det gick inte att ansluta. Försök igen.' : 'Could not connect. Please try again.';
  return sv ? 'Koden är felaktig eller har gått ut. Kontrollera senaste mejlet eller begär en ny kod.' : 'The code is invalid or expired. Check your latest email or request a new code.';
}
